<template>
  <v-container>
    <ResalePropertyListCriteria :baseCrudKey="baseCrudKey"
      @loadCRUDList="searchByCriteria" class="mt-n3" />
    <template>
      <v-row>
        <v-col cols="9">
          <CRUDList ref="crudList" :canAdd="false" :canEdit="true" :canCancel="false"
            :canSave="false" :showSelect="false" :canDeleteInDialog="true"
            :enableFixedHeaders="true" :displayTopPagination="false" :headers="headers"
            :baseCrudKey="baseCrudKey" :dialogHeaderName="dialogHeaderName"
            :defaultSortBy="defaultSortBy" dialogDynamicWidth="60vw"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table' tableDynamicHeight="250"
            @deleteItem="deleteFromDiaglog"
            @loadCRUDList="handleLoadList" @onSingleClicked="handleSingleOrArrowClick"
            @onArrowUpOrDown="handleSingleOrArrowClick" :loadingData="gridLoading.flag"
            :loadingText="gridLoading.text">
            <template v-slot:additionalActionsTopAboveRow>
              <v-row class="pa-0 mb-n10">
                <v-col cols="11"></v-col>
                <v-col cols="1">
                  <v-btn color="primary" fab icon small class="ml-n1"
                    @click="openAddNewRecordDialog()">
                    <v-icon small>
                      {{icons.mdiPlus}}
                    </v-icon>
                  </v-btn>
                  </v-col>
                </v-row>
            </template>
            <template v-slot:[`editedItem`]="{ }">
              <ResalePropertyListDialog :baseCrudKey="baseCrudKey" @loadCRUDList="handleLoadList"
              :baseCrudKeyForResaleDetails="baseCrudKeyForResaleDetails"
              :saleYear="dialogSaleYear" />
            </template>
            <template v-slot:addidtionalCrudFooter>
             <h4 class="input-text-size pt-3 pl-1">RECORD COUNT: {{ recordsCount }}</h4>
            </template>
            <template v-slot:[`additionalActionsAfterSave`]="{}">
              <v-btn class="input-text-size" text
                color="blue darken-1" @click="upsertResaleList()">
                Save
              </v-btn>
              <v-btn class="input-text-size" text
                  color="blue darken-1" @click="closeCRUDListDialog()">
                Cancel
              </v-btn>
          </template>
          </CRUDList>
        </v-col>
        <v-col cols="3">
          <v-row>
            <v-col cols="6" class="pa-0 pr-1 mt-3">
              <ClarionDateControl class="input-text-size" :isToggle="false"
              :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
              v-model="penaltyDateValue" label="Penalty Date" />
            </v-col>
            <v-col cols="6" class="pa-0 mt-6 pl-5">
              <v-btn color="primary" small rounded :loading="isRecalculating"
                :class="resalePenaltyStaleBtnClass"
                :disabled="isRecalculating" @click="handleRecalculate()">Recalculate</v-btn>
              <ResalePenaltyStaleWarning :isStale="isResalePenaltyOutdated" />
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-select :items="listActions" class="input-text-size" label="List Actions"
              item-value="val" item-text="listName" v-model="listActionsVal" />
            </v-col>
            <v-col cols="12" class="pa-0">
              <ResaleListActionList :listActionsVal="listActionsVal" v-model="editItemList" />
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-btn color="primary" small rounded :loading="isRunningListAction"
                :disabled="isRunningListAction" @click="handleActions()">Go</v-btn>
            </v-col>
            <v-col cols="12" class="pa-0 mt-2">
              <v-btn color="primary" small rounded @click="handleNotificationLetter()">
                Notification Letter</v-btn>
            </v-col>
            <v-col cols="12" class="pa-0 mt-2">
              <v-btn color="primary" small rounded @click="handleCertifiedMailer()">
                Certified Mailer</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <ResalePropertDetailsList class="mt-n9" @handleDialogItem="handleDialogItem"
        :baseCrudKey="baseCrudKeyForResaleDetails" :ResalePropertyBaseCrudKey="baseCrudKey"
        :isItFromResalePropertyDialog="false" />

        <CRUDDialog ref="crudDialogForAddNewRecord" :baseCrudKey="baseCrudKeyForAddNewRecord"
        dialogDynamicWidth="30vw" :canSave="false" :canCancel="false"
        onlyDialogHeaderName="Add Record to Resale List">
          <template v-slot:[`editedItem`]="{ }">
            <v-text-field class="input-text-size" label="Tax Year(Base Year)"
             v-model.number="addNewRecord.taxYear" type="number" :rules="rules"/>
            <v-text-field class="input-text-size" label="Tax ID" v-model.number="addNewRecord.taxId"
             type="number" :rules="rules" />
          </template>
          <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text
          color="blue darken-1" @click="handleAddNewRecord()">
          OK
        </v-btn>
        <v-btn class="input-text-size" text
          color="blue darken-1" @click="closeAddNewRecordDialog()">
          Cancel
        </v-btn>
    </template>
      </CRUDDialog>
      <JuneResalePublicationDialog
        v-model="showPublicationDialog"
        :penaltyDate="penaltyDateValue"
        :header="publicationHeader"
        :taxInquiryData="publicationTaxInquiryData"
        @generate="handlePublicationGenerate"
      />
    </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapGetters,
  mapState,
} from 'vuex';
import { mdiPlus } from '@mdi/js';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { resaleConfigScope } from '../../../../../util/shared/system-config-scopes';
import { amountToNumber, defaultGridLoading, manageGridLoading } from '../../../../../util/shared/vue-global';
import ResalePropertyListDialog from './ResalePropertyDialog/ResalePropertyListDialog.vue';
import { juneResaleMainHeader, resaleListActions, resaleListActionsWhenResaleDateIsLessThanCurDate } from '../../deliquentUtils/deliquent.utils';
import ResalePropertDetailsList from './ResalePropertDetailsList.vue';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import { juneResaleCommonPostProcessTrans, makeCriteriaStateNullIfEmptyString } from '../../../common-utils/CommonTaxFunctionalities';
import ResaleListActionList from './ResaleListActionList.vue';
import { toIsoDate } from '../../../../../util/shared/tmc-global';
import CRUDDialog from '../../../../common/base/crud-2.0/CRUDDialog.vue';
import { generateQueryString } from '../../../../common/base/report/report-util';
import { clients } from '../../../../../util/clients';
import JuneResalePublicationDialog from './ResalePropertyDialog/JuneResalePublicationDialog.vue';
import { transformMapperListFields } from '../../../../../util/shared/transform';
import ResalePropertyListCriteria from './ResalePropertyListCriteria.vue';
import ResalePenaltyStaleWarning from '../ResalePenaltyStaleWarning.vue';
import resalePenaltyStaleMixin from '../resalePenaltyStale.mixin';
import '../../../../../assets/style.css';

const { backendRest } = clients.direct;

export default {
  name: 'ResalePropertyList',
  mixins: [resalePenaltyStaleMixin],
  components: {
    CRUDList,
    CRUDDialog,
    ClarionDateControl,
    ResalePropertyListDialog,
    ResalePropertDetailsList,
    ResaleListActionList,
    JuneResalePublicationDialog,
    ResalePropertyListCriteria,
    ResalePenaltyStaleWarning,
  },
  data() {
    return {
      baseCrudKey: 'ResalePropertyList',
      baseCrudKeyForResaleDetails: 'ResalePropertyListDetails',
      baseCrudKeyForAddNewRecord: 'AddNewRecordToJuneResale',
      dialogHeaderName: 'June Resale Record',
      headers: juneResaleMainHeader,
      listActions: resaleListActions,
      listActionsVal: 0,
      gridLoading: defaultGridLoading(),
      // the list actions stream the whole sale year on the backend and can run for
      // several seconds - without this the Go button stays live and a second click
      // starts a concurrent run over the same records
      isRunningListAction: false,
      // recalculating penalty walks every record of the sale year on the backend, so the
      // button has to stay busy until the follow-up reload lands - otherwise a second click
      // recalculates over records that are still being written
      isRecalculating: false,
      isItFirstCallOrNot: false,
      penaltyDateValue: null,
      editItemList: {
        feeNumber: null,
        feeAmount: null,
        effectiveDate: null,
      },
      icons: {
        mdiPlus,
      },
      addNewRecord: {
        taxYear: null,
        taxId: null,
      },
      recordsCount: 0,
      publicationHeader: 'Publication TXT Settings',
      showPublicationDialog: false,
      publicationTaxInquiryData: {},
    };
  },
  mounted() {
    if (this.latestSaleYear) {
      this.isItFirstCallOrNot = true;
      this.handleLoadList();
      this.isTheResaleDateLessThanCurrentDate();
    }
  },
  watch: {
    latestSaleYear(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.saleYear = this.latestSaleYear;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadList();
        this.isTheResaleDateLessThanCurrentDate();
      }
    },
    isVisibleResaleList(val) {
      if (val) this.setDefaultSelectedItems();
    },
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item', 'criteria']),
    ...mapState({
      latestSaleYear: (state) => state.tax.juneResale.latestSaleYear,
      isVisibleResaleList: (state) => state.base.crud.isVisible.ResalePropertyList,
      highlightedId: (state) => state.base.crud.highlightedId.ResalePropertyList,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
      statementSettingItem: (state) => state.SystemConfig.statementSettingItem || {},
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'systemId',
          direction: 'asc',
        },
      ];
    },
    // 'All Years' (0) is fine for browsing, but every action on this screen is scoped to one
    // sale year - the backend helpers all run find({ saleYear }), so a 0 would match nothing
    // and report success for a run that touched no records
    hasSaleYearSelected() {
      return Boolean(Number(this.criteriaState.saleYear));
    },
    dialogSaleYear() {
      // the dialog writes this year onto the record's name/address document, so under
      // 'All Years' fall back to the year the selected record itself belongs to
      const selectedItem = this.item(this.baseCrudKey) || {};
      return Number(this.criteriaState.saleYear) || Number(selectedItem.saleYear) || null;
    },
    rules() {
      return [
        (v) => {
          if (Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapActions('tax/juneResale', [
      'loadJuneResale',
      'deleteJuneResale',
      'juneResaleAddFees',
      'juneResaleRecalculatePenalty',
      'upsertJuneResaleSelectedFields',
      'getJuneResaleCountBasedOnSaleYear',
      'addANewRecordToJuneResale',
      'removePaidRecordsFromJuneResale',
      'disableWebPaymentsJuneResale',
      'pullAllRecordsForCurrentJuneResale',
    ]),
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    ...mapActions('SystemConfig', [
      'updateConfig',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
    ]),
    ...mapActions(['custumColrFlashMsg', 'reAuth']),
    isTheResaleDateLessThanCurrentDate() {
      // Once we have gotten past the date of the resale, we want to disable the 'Remove Paids' and the 'Pull All Records for Current
      // Resale List' options from the list actions dropdown list.  We want to do this so that we can preserve the data after the sale.
      // But since the records get marked as paid by the payments created during the resale, the list would get wiped out by remove paids, or zeroed out by the 'pull all records...' utility.
      const { resaleSaleDate } = this.resaleSettingItem;
      const checkYearsAreSame = Number(this.criteriaState.saleYear) === new Date(resaleSaleDate).getFullYear();

      // const saleDate = new Date(resaleSaleDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // normalize to start of day

      // const isBeforeToday = saleDate <= today;

      // const isValid = checkYearsAreSame && isBeforeToday;
      const isValid = checkYearsAreSame;

      if (isValid) this.listActions = resaleListActions;
      else this.listActions = resaleListActionsWhenResaleDateIsLessThanCurDate;
    },
    deleteFromDiaglog(deleteItem) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        const item = {
          _id: deleteItem._id,
          systemId: deleteItem.systemId,
        };
        this.deleteJuneResale({ item, baseCrudKey });
      }
    },
    async handleLoadList(retaiItemId, systemId) {
      if (this.isItFirstCallOrNot) {
        // this is needed to load the resale setting item, to get the penalty date value -
        // and it is the same saved date the "Penalty outdated" warning is judged against,
        // so re-reading it here is what clears the warning after a recalculation
        await this.refreshResalePenaltyStaleCheck();
        this.selectedRowData = {};
        manageGridLoading(this, true, 'Searching...');
        const { baseCrudKey } = this;
        const criteria = {
          ...this.criteriaState,
          resaleSortByParcelComponents: this.resaleSettingItem.resaleSortByParcelComponents || false,
        };
        const itemToSent = {
          saleYear: Number(criteria.saleYear || 0),
          // the count is the RECORD COUNT under the grid, so it has to see the same
          // wildcard the grid was filtered by
          wildCard: criteria.wildCard || null,
        };
        this.getJuneResaleCountBasedOnSaleYear({ itemToSent }).then((res) => {
          this.recordsCount = res || 0;
        });
        // held so callers can await the reload - the Recalculate / Go spinners stay up until
        // the grid actually shows the new numbers
        const loadPromise = this.loadJuneResale({
          criteria, baseCrudKey, postProcessTrans: this.postProcessForResaleList,
        }).then((res) => {
          this.setDefaultSelectedItems();
          // this if and else block is nedded when the user delete the records from the dialog
          if (retaiItemId) { // when the user delete the records from the dialog
            const filterItem = (res || []).filter((ft) => ft._id === retaiItemId);
            if (filterItem.length) {
              this.setItem([baseCrudKey, filterItem[0]]);
              this.setItems([this.baseCrudKeyForResaleDetails, filterItem[0].taxDetails]);
            }
          } else if (systemId) { // when the user pull the current details to the resale list
            const filterItem = (res || []).filter((ft) => ft.systemId === systemId);
            if (filterItem.length) {
              this.setItem([baseCrudKey, filterItem[0]]);
              this.setItems([this.baseCrudKeyForResaleDetails, filterItem[0].taxDetails]);
            }
          } else {
            this.setItem([baseCrudKey, {}]);
            this.setItems([this.baseCrudKeyForResaleDetails, []]);
          }
        }).finally(() => {
          manageGridLoading(this, false);
        });
        // set the penalty date value from the resale setting item
        this.penaltyDateValue = this.resaleSettingItem.resalePenaltyDate || this.penaltyDateValue;
        return loadPromise;
      }
      return null;
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
      });
    },
    postProcessForResaleList(items) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const alteredItems = juneResaleCommonPostProcessTrans(items, formatPidPositions);
      return alteredItems;
    },
    postProcessAdjTypesUpdate(items) {
      const item = { ...items };
      item.assessorCodes = item.assessorCodes ? item.assessorCodes.join(',') : '';
      return item;
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.handleLoadList();
      this.isTheResaleDateLessThanCurrentDate();
    },
    handleSingleOrArrowClick(fromCrud) {
      if ((fromCrud.taxDetails || []).length) {
        this.setItems([this.baseCrudKeyForResaleDetails, fromCrud.taxDetails]);
      }
    },
    handleDialogItem() {
      const selectedItem = this.item(this.baseCrudKey);
      this.$refs.crudList.handleEditItem(selectedItem);
    },
    async handleActions() {
      if (this.isRunningListAction) return;
      this.isRunningListAction = true;
      try {
        await this.runListAction();
      } finally {
        this.isRunningListAction = false;
      }
    },
    async runListAction() {
      const { saleYear } = this.criteriaState;
      if (this.listActionsVal && !this.hasSaleYearSelected) {
        this.custumColrFlashMsg({ msg: 'Please select a single Resale Year to run a list action' });
        return;
      }
      if (this.listActionsVal === 1) {
        const itemToSent = {
          saleYear,
        };
        await this.removePaidRecordsFromJuneResale({ itemToSent });
        await this.handleLoadList();
        const { jwt } = await this.reAuth();

        const params = [
          `token=${jwt}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/juneResale/resale-remove-paid-records${queryString}`;
        window.open(url, '_blank');
      } else if (this.listActionsVal === 2) {
        const itemToSent = {
          saleYear,
        };
        await this.pullAllRecordsForCurrentJuneResale({ itemToSent });
        await this.handleLoadList();
      } else if (this.listActionsVal === 3) {
        console.info('3');
      } else if (this.listActionsVal === 4) {
        const itemToSent = {
          saleYear,
        };
        await this.disableWebPaymentsJuneResale({ itemToSent });
        await this.handleLoadList();
      } else if (this.listActionsVal === 5) {
        const {
          feeNumber, feeAmount, effectiveDate,
        } = this.editItemList;
        if (feeNumber && amountToNumber(feeAmount) && saleYear) {
          const itemToSent = {
            feeNumber,
            feeAmount: amountToNumber(feeAmount),
            saleYear,
            effectiveDate: effectiveDate ? toIsoDate(effectiveDate) : null,
          };
          await this.juneResaleAddFees({ itemToSent });
          await this.handleLoadList();
        } else {
          this.custumColrFlashMsg({ msg: 'Please enter required fields' });
        }
      } else if (this.listActionsVal === 6) {
        this.openPublicationDialog();
      } else if (this.listActionsVal === 7) {
        if (saleYear) await (this.exportUrl({ formatFile: 'JUNE_RESALE_EXPORT.csv' }) || '');
        else this.custumColrFlashMsg({ msg: 'Please select the Resale Year' });
      } else {
        this.custumColrFlashMsg({ msg: 'Please select list actions' });
      }
    },
    async exportUrl({ formatFile }) {
      const { saleYear } = this.criteriaState;
      let mongoId = '';
      let collectionName = '';
      let fileName = '';
      let itemData = [];
      const criteria = {
        type: 'export',
        program: 'TAX',
      };
      await this.loadTransformMappers({
        criteria,
        fields: { ...transformMapperListFields },
        baseCrudKey: 'transform-mapper-list',
      }).then(() => {
        itemData = this.items('transform-mapper-list');
      });
      for (let i = 0; i < (itemData || []).length > 0; i += 1) {
        const item = itemData[i];
        if (item.fileName === formatFile) {
          fileName = item.fileName;
          mongoId = item._id;
          collectionName = item.collectionName;
        }
      }
      const { jwt } = await this.reAuth();

      const backendURL = backendRest.defaults.baseURL;
      const encodedSaleYear = encodeURIComponent(saleYear);
      const url = `${backendURL}/transmap/export?fileHeaders=true&id=${mongoId}&fileName=${fileName}&collectionName=${collectionName}&saleYear=${encodedSaleYear}&program=TAX&token=${jwt}`;
      if (url && url !== '' && !url.match(/NaN/) && !url.match(/\/$/)) {
        window.open(url, '_blank');
      }
    },
    async handleNotificationLetter() {
      if (!this.hasSaleYearSelected) {
        this.custumColrFlashMsg({ msg: 'Please select a single Resale Year' });
        return;
      }
      const { jwt } = await this.reAuth();
      if (!this.highlightedId) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }

      const params = [
        `token=${jwt}`,
        `resaleYear=${this.criteriaState.saleYear}`,
        `recordId=${this.highlightedId}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/juneResale/resale-notification-letter${queryString}`;
      window.open(url, '_blank');
    },
    async handleCertifiedMailer() {
      if (!this.hasSaleYearSelected) {
        this.custumColrFlashMsg({ msg: 'Please select a single Resale Year' });
        return;
      }
      const { jwt } = await this.reAuth();
      if (!this.highlightedId) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }

      const params = [
        `token=${jwt}`,
        `resaleYear=${this.criteriaState.saleYear}`,
        `recordId=${this.highlightedId}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/juneResale/certified-mailers${queryString}`;
      window.open(url, '_blank');
    },
    async handleRecalculate() {
      if (this.isRecalculating) return;
      const { saleYear } = this.criteriaState;
      if (!this.penaltyDateValue) {
        this.custumColrFlashMsg({ msg: 'Please select penalty date' });
        return;
      }
      // without this the 'All Years' case fell through both branches and the button did
      // nothing at all, with no message
      if (!this.hasSaleYearSelected) {
        this.custumColrFlashMsg({ msg: 'Please select a single Resale Year to recalculate' });
        return;
      }
      const itemToSent = {
        saleYear,
        penaltyDate: toIsoDate(this.penaltyDateValue),
      };
      this.isRecalculating = true;
      try {
        await this.juneResaleRecalculatePenalty({ itemToSent });
        const item = resaleConfigScope.mergeForPersist(this.resaleSettingItem, {
          resalePenaltyDate: this.penaltyDateValue,
        });
        await this.updateConfig({ calledScope: 'resaleConfig', item });
        await this.handleLoadList();
      } finally {
        this.isRecalculating = false;
      }
    },
    openAddNewRecordDialog() {
      this.setIsVisible([this.baseCrudKeyForAddNewRecord, true]);
    },
    closeAddNewRecordDialog() {
      this.addNewRecord = {
        taxYear: null,
        taxId: null,
      };
      this.setIsVisible([this.baseCrudKeyForAddNewRecord, false]);
    },
    closeCRUDListDialog() {
      this.setIsVisible([this.baseCrudKey, false]);
    },
    upsertResaleList() {
      const item = this.item(this.baseCrudKey);
      if (!item._id) return;

      const itemToSent = {
        mainCurrentOwnerName: item.mainCurrentOwnerName,
        mainLegalDesc: item.mainLegalDesc,
        _id: item._id,
      };
      this.upsertJuneResaleSelectedFields({ itemToSent }).then(() => {
        this.closeCRUDListDialog();
        this.handleLoadList();
      });
    },
    handleAddNewRecord() {
      const validate = this.$refs.crudDialogForAddNewRecord.validateForm();
      if (!validate) return;
      const { saleYear } = this.criteriaState;
      if (saleYear) {
        const itemToSent = {
          saleYear,
          taxId: Number(this.addNewRecord.taxId || 0),
          taxYear: Number(this.addNewRecord.taxYear || 0),
        };
        this.addANewRecordToJuneResale({ itemToSent }).then(() => {
          this.closeAddNewRecordDialog();
          this.handleLoadList();
        });
      } else {
        this.custumColrFlashMsg({ msg: 'Sale year is required' });
      }
    },
    async openPublicationDialog() {
      // Get filter criteria from baseCrudKey
      const items = this.items(this.baseCrudKey);
      if (!items || items.length === 0) {
        this.custumColrFlashMsg({ msg: 'No browse list data available' });
        return;
      }
      const browseItems = items[0] || {};

      const { mainTaxId, mainTaxYear, taxDetails } = browseItems;

      let taxId = mainTaxId;
      let taxYear = mainTaxYear;
      if ((taxDetails || []).length) {
        const getLatestRealRecords = taxDetails.sort((a, b) => b.taxYear - a.taxYear).filter((ft) => ft.taxType.toLowerCase() === 'r');
        if (getLatestRealRecords.length) {
          const getLatestRealRecord = getLatestRealRecords[0];
          taxId = getLatestRealRecord.taxId;
          taxYear = getLatestRealRecord.taxYear;
        }
      }

      if (!taxId || !taxYear) {
        this.custumColrFlashMsg({ msg: 'Missing taxId or taxYear in browse data' });
        return;
      }

      try {
        const taxInquiryData = await this.loadTaxInquires({
          criteria: { taxId, taxYear },
        });

        if (taxInquiryData.length) {
          const taxDetail = taxInquiryData[0];
          browseItems.addition = taxDetail.addition || '';
          browseItems.lots = taxDetail.lots || '';
          browseItems.block = taxDetail.block || '';
          browseItems.name1 = taxDetail.name1 || '';
          browseItems.name2 = taxDetail.name2 || '';
          browseItems.inCareOf1 = taxDetail.inCareOf1 || '';
          browseItems.inCareOf2 = taxDetail.inCareOf2 || '';
        }

        // Load delinquent tax records based on basId
        // if (mainBaseId) {
        //   try {
        //     const delinquentTaxData = await this.loadTaxInquires({
        //       criteria: { baseId: mainBaseId, delq: true },
        //     });
        //     if (delinquentTaxData.length) {
        //       browseItems.taxDetails = delinquentTaxData;
        //     } else {
        //       browseItems.taxDetails = [];
        //     }
        //   } catch (delinquentError) {
        //     console.warn('Could not load delinquent tax data:', delinquentError);
        //   }
        // }
        this.publicationTaxInquiryData = browseItems;

        // Open the new isolated dialog
        this.showPublicationDialog = true;
      } catch (error) {
        this.custumColrFlashMsg({ msg: 'Error loading tax inquiry data' });
      }
    },
    async handlePublicationGenerate(publicationSettings) {
      // Handle generation from the new isolated dialog
      this.generatePublicationWithSettings(publicationSettings);
    },
    async generatePublicationWithSettings(publicationSettings) {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;

      // if (!criteria.name) {
      //   window.confirm('please select file name to proceed');
      //   return;
      // }

      const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

      // Extract values from the publication settings
      const {
        taxId, parcelId, ownerName, situsAddress, includeDelinquents, includeHeaders,
        taxPenaltyFeesDue, totalDue, descriptionType, amountDisplayType, printOrder, penaltyDate,
        includeNameTwo, includeCareOf,
      } = publicationSettings;

      const params = [
        `token=${jwt}`,
        `filters=${encodedCriteria}`,
        `resaleYear=${this.criteriaState.saleYear}`,
        `includeTaxId=${Boolean(taxId)}`,
        `includeParcelId=${Boolean(parcelId)}`,
        `includeOwnerName=${Boolean(ownerName)}`,
        `includeSitusAddress=${Boolean(situsAddress)}`,
        `includeNameTwo=${Boolean(includeNameTwo)}`,
        `includeCareOf=${Boolean(includeCareOf)}`,
        `includeDelinquents=${Boolean(includeDelinquents)}`,
        `includeLegalDescription=${descriptionType === 'legalDescription'}`,
        `includeAdditionLotAndBlock=${descriptionType === 'additionLotAndBlock'}`,
        `includeTaxPenaltyFeesDue=${Boolean(taxPenaltyFeesDue)}`,
        `includeTotalDue=${Boolean(totalDue)}`,
        `includeTotalDueOnly=${amountDisplayType === 'totalDueOnly'}`,
        `includeSeparateAmounts=${amountDisplayType === 'separateAmounts'}`,
        `orderByName=${printOrder === 'orderOwnerName'}`,
        `orderByTaxId=${printOrder === 'orderTaxId'}`,
        `orderByParcelId=${printOrder === 'orderPID'}`,
        `penaltyDate=${toIsoDate(penaltyDate)}`,
        `includeHeaders=${Boolean(includeHeaders)}`,
      ];

      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }

      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/juneResale/publication-txt${queryString}`;
      window.open(url, '_blank');

      // Close the dialog after generating
      this.setIsVisible([this.publicationCrudKey, false]);
    },
  },
};
</script>
